<template>
    <transition name="fade-up">
        <div v-if="$vssWidth <= 640 && isVisible" class="order-sticky-button">
            <p v-if="order.cost_info.price.amount">
                {{ t("payments.invoice_amount_due") }}:<span class="ml-14">{{
                    order.price_info.price.amount_formatted
                }}</span>
            </p>
            <DefaultButton :height="45" @click="scrollIntoBlock" :background="background" :text="text" />
        </div>
    </transition>
</template>

<script>
import DefaultButton from "@components/Buttons/DefaultButton.vue"

export default {
    props: {
        order: {
            type: Object,
            default: null
        },
        background: {
            type: String,
            default: ""
        },
        text: {
            type: String,
            default: ""
        }
    },
    name: "PublicOfferOrderStickyButton",
    components: { DefaultButton },
    data() {
        return {
            isVisible: true
        }
    },
    methods: {
        scrollIntoBlock() {
            const target = document.querySelector(".public-offer-order")

            if (!target) {
                return
            }

            target.scrollIntoView({ behavior: "smooth", block: "end" })
        }
    },
    mounted() {
        const target = document.querySelector(".public-offer-order")

        if (!target) {
            return
        }

        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    this.isVisible = !entry.isIntersecting
                })
            },
            { threshold: 0 }
        )

        observer.observe(target)
    }
}
</script>

<style scoped lang="scss">
.order-sticky-button {
    background-color: #51565c;
    position: fixed;
    bottom: 0;
    width: 100vw;
    z-index: 9999999999999999999;
    line-height: 160%;
    font-size: 16px;
    left: 0;
    color: #ffffff;
    box-shadow: 0 -2px 10px rgba(128, 158, 191, 0.15);
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    grid-gap: 15px;
}
</style>
